import { SharedModule } from './../shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminRoutingModule } from './admin-routing.module';
import { AdminComponent } from './admin.component';
import { AdminHomeComponent } from './components/admin-home/admin-home.component';
import { MyProfileComponent } from './components/my-profile/my-profile.component';
import { UsersComponent } from './components/users/users.component';
import { RolesComponent } from './components/roles/roles.component';
import { LogGridComponent } from './components/log-view/log-grid/log-grid.component';
import { LogDetailsComponent } from './components/log-view/log-details/log-details.component';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { AdminConfigComponent } from './components/admin-config/admin-config.component';


@NgModule({
    declarations: [
        AdminComponent,
        AdminHomeComponent,
        MyProfileComponent,
        UsersComponent,
        AdminConfigComponent,
        RolesComponent,
        LogGridComponent,
        LogDetailsComponent,
    ],
    imports: [
        CommonModule,
        AdminRoutingModule,
        SharedModule,
        PaginationModule.forRoot()
    ]
})
export class AdminModule {

}
